import { PlussCore } from '../config/core';
import _ from 'lodash';

export const compileStats = PlussCore.Analytics.compileStats;
export const getInsight = PlussCore.Analytics.getInsight;
export const getAnalyticsFilterOptions = PlussCore.Analytics.getAnalyticsFilterOptions;
export const countActivities = PlussCore.Analytics.countActivities;
export const generateDateRangeObjects = PlussCore.Analytics.generateDateRangeObjects;
export const generateDateActivities = PlussCore.Analytics.generateDateActivities;
